const translations={
    es: {
      welcome: "Bienvenido a Pia Wak",
      subtitle: "Crea tu cuenta de operador turístico y comienza a ofrecer tus servicios de forma profesional.",
      motto: '"Haz que cada tour sea inolvidable. Comienza hoy."',
      registerTitle: "Registro de Operador",
      name: "Nombre",
      lastName1: "Primer Apellido",
      lastName2: "Segundo Apellido",
      email: "Correo Electrónico",
      password: "Contraseña",
      confirmPassword: "Confirmar Contraseña",
      phone: "Teléfono",
      location: "Ubicación",
      pictureLabel: "Foto de Perfil (URL o archivo)",
      description: "Descripción del operador o los servicios que ofrece",
      register: "Registrar",
      passwordError: "Las contraseñas no coinciden. Por favor, verifica e intenta de nuevo.",
      serverError: "Error de conexión con el servidor.",
      switchLang: "Cambiar a Inglés",
      passwordRequirements: "La contraseña debe contener:",
      reqLength: "Al menos 8 caracteres",
      reqUppercase: "Una letra mayúscula",
      reqLowercase: "Una letra minúscula",
      reqNumber: "Un número",
      reqSpecialChar: "Un carácter especial",
      reqNoSpaces: "Sin espacios",
      nameError: "Solo letras y un espacio entre nombres",
      lastNameError: "Solo letras y un espacio entre apellidos",
      fieldRequired: "Este campo es requerido",
      minLength: "Mínimo 2 caracteres",
      noNumbers: "No se permiten números",
      noMultipleSpaces: "No se permiten múltiples espacios",
      noEdgeSpaces: "No se permiten espacios al inicio/final",
      uploadError: "Error al subir la imagen.",
      genericError: "Ocurrió un error.",
      phoneErrorPrefix: "Use +506 prefix or write 8 digits without prefix.",
     phoneErrorInvalid: "Invalid Costa Rican number. Valid formats: 88887777 or +50688887777.",
     name_submerchant:"Nombre comercial",
     name_submerchant_error:"El nombre comercial es requerido, este fue enviado en un email"
    },
    en: {
      welcome: "Welcome to Pia Wak",
      subtitle: "Create your operator account and start offering your services professionally.",
      motto: '"Make every tour unforgettable. Start today."',
      registerTitle: "Operator Registration",
      name: "First Name",
      lastName1: "Last Name",
      lastName2: "Second Last Name",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      phone: "Phone",
      location: "Location",
      pictureLabel: "Profile Picture (URL or file)",
      description: "Description of the operator or the services you offer",
      register: "Register",
      passwordError: "Passwords do not match. Please verify and try again.",
      serverError: "Server connection error.",
      switchLang: "Switch to Spanish",
      passwordRequirements: "Password must contain:",
      reqLength: "At least 8 characters",
      reqUppercase: "One uppercase letter",
      reqLowercase: "One lowercase letter",
      reqNumber: "One number",
      reqSpecialChar: "One special character",
      reqNoSpaces: "No spaces",
      nameError: "Only letters and one space between names",
      lastNameError: "Only letters and one space between last names",
      fieldRequired: "This field is required",
      minLength: "Minimum 2 characters",
      noNumbers: "Numbers not allowed",
      noMultipleSpaces: "Multiple spaces not allowed",
      noEdgeSpaces: "No leading/trailing spaces",
      uploadError: "Error uploading image.",
      genericError: "An error occurred.",
      phoneErrorPrefix: "Use +506 prefix or write 8 digits without prefix.",
      phoneErrorInvalid: "Invalid Costa Rican number. Valid formats: 88887777 or +50688887777.",
      name_submerchant:"Trade name",
      name_submerchant_error: "The business name is required, this name it was send in the email"

    },
  }

  export default translations